import { ThemeOptions } from '@mui/material/styles';
import { colors } from './colors';

import { typography } from './typography';
import { breakpoints } from './breakpoints';
import { getComponents } from './components';
import { spacing } from './spacing';

// Light mode palette
const lightPalette = {
  mode: 'light' as const,
  primary: colors.primary,
  secondary: colors.secondary,
  success: colors.success,
  error: colors.error,
  warning: colors.warning,
  info: colors.info,
  grey: colors.grey,
  background: {
    default: '#F9FAFB',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#1F2937',
    secondary: '#4B5563',
    disabled: '#9CA3AF',
  },
  divider: '#E5E7EB',
  action: {
    active: '#6B7280',
    hover: 'rgba(0, 0, 0, 0.04)',
    selected: 'rgba(0, 0, 0, 0.08)',
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
};

// Generate design tokens (light mode only)
export const getDesignTokens = (): ThemeOptions => {
  return {
    palette: lightPalette,
    typography,
    breakpoints,
    components: getComponents(),
    spacing: spacing.unit,
    shape: {
      borderRadius: 8,
    },
  };
};

// Export individual theme modules
export { colors, greyLightMode } from './colors';
export { typography, textStyles } from './typography';
export { breakpoints, isMobile, isTablet, isDesktop, getResponsiveSize } from './breakpoints';
export type { ResponsiveSize } from './breakpoints';
export { spacing, sp, gaps } from './spacing';
export { getComponents } from './components';
